import React, { useEffect, useRef, useState } from "react";
import styled from 'styled-components';
import {breakpoints} from "../components/constants";

// TEMPORARY route — D.O.S slot typology / 3D trait atlas.
// The document is a self-contained HTML page (three.js r128 + inline scripts)
// served statically from public/tmp/, so it is embedded rather than ported.

// Root's PageContent adds a 50px top padding on desktop; this route needs the
// full remaining viewport, so the padding is cancelled here only.
const TmpFrame = styled.iframe`
    border: none;
    display: block;
    width: 100%;

    @media only screen and (min-width: ${breakpoints.md}px){
        margin-top: -50px;
    }
`

const Tmp = () => {
    const ref = useRef(null);
    const [height, setHeight] = useState('100vh');

    useEffect(() => {
        const fit = () => {
            if(!ref.current) return;
            const top = ref.current.getBoundingClientRect().top + window.scrollY;
            setHeight(Math.max(320, window.innerHeight - top) + 'px');
        };
        fit();
        window.addEventListener('resize', fit);
        return () => window.removeEventListener('resize', fit);
    }, []);

    return (
        <TmpFrame
            ref={ref}
            id="dosTraits3d"
            title="D.O.S — SLOT TYPOLOGY / 3D"
            sandbox="allow-scripts allow-same-origin allow-pointer-lock"
            src="/tmp/dos-traits-3d.html"
            style={{height}}
        />
    )
}

export default Tmp;
